import styles from "./consts.module.scss";

export const COLORS = {
  GREEN: styles.var_darkGreen,
  LIGHT_GREEN: styles.var_lightGreen,
  WHITE: "#FFFFFF",
  THEME: "#FFF",
  TRANSPARENT: "TRANSPARENT"
};

export const SIZES = {
  XXSMALL: "XXSMALL",
  XSMALL: "XSMALL",
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE"
};

export type Size = keyof typeof SIZES;
export type Color = (typeof COLORS)[keyof typeof COLORS];
